// GARDP Tabs functionality
document.addEventListener('DOMContentLoaded', function() {
  initTabs();
  handleHashNavigation();
});

function initTabs() {
  // Find all tab button containers
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');

  if (tabButtons.length === 0 || tabContents.length === 0) {
    return;
  }

  // Initialize - set first tab as active
  setActiveTab(1);

  // Add click handlers to all tab buttons
  tabButtons.forEach((button) => {
    const link = button.querySelector('a');
    if (link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Extract tab number from href (e.g., "#tab-1" -> 1)
        const href = this.getAttribute('href');
        const tabNumber = href.replace('#tab-', '');
        
        setActiveTab(tabNumber);
        
        // Update URL hash without full page reload
        window.history.pushState(null, null, href);
      });
    }
  });
}

function setActiveTab(tabNumber) {
  // Remove active class from all buttons and contents
  document.querySelectorAll('.tab-button').forEach(btn => {
    btn.classList.remove('is-active');
  });
  
  document.querySelectorAll('.tab-content').forEach(content => {
    content.classList.remove('is-active');
  });

  // Add active class to the selected tab
  const activeButton = document.querySelector(`.tab-button-${tabNumber}`);
  const activeContent = document.querySelector(`.tab-content-${tabNumber}`);

  if (activeButton) {
    activeButton.classList.add('is-active');
  }

  if (activeContent) {
    activeContent.classList.add('is-active');
  }
}

// Handle direct navigation via URL hash (e.g., visiting #tab-2)
function handleHashNavigation() {
  const hash = window.location.hash;
  
  if (hash && hash.startsWith('#tab-')) {
    const tabNumber = hash.replace('#tab-', '');
    setActiveTab(tabNumber);
  }
  
  // Also listen for hash changes
  window.addEventListener('hashchange', function() {
    const hash = window.location.hash;
    if (hash && hash.startsWith('#tab-')) {
      const tabNumber = hash.replace('#tab-', '');
      setActiveTab(tabNumber);
    }
  });
}
